import { use } from "react";

import { GlobalFiltersContext } from "@/providers/globalFiltersConfig";

export function useGlobalFilters() {
  return use(GlobalFiltersContext);
}
